"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MyTasksFilterPanel;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_hook_form_1 = require("react-hook-form");
const RepositoryReact_1 = __importDefault(require("../../React/RepositoryReact"));
const BussinesObjectSelectors_1 = require("../../View/Modals/CommonFormComponents/BussinesObjectSelectors");
const StatusSelectors_1 = require("../../View/Modals/CommonFormComponents/StatusSelectors");
const FormContext_1 = require("../../View/Modals/FormContext");
/** Wąski, pionowy zestaw selektorów (reużyte z „Projekty i zadania"). */
function Body() {
    const { watch, setValue } = (0, FormContext_1.useFormContext)();
    const _contract = watch("_contract");
    const casesFilterRepository = (0, react_1.useMemo)(() => new RepositoryReact_1.default({
        actionRoutes: { getRoute: "cases", addNewRoute: "", editRoute: "", deleteRoute: "" },
        name: "scrumMyTasksCasesFilter_temp",
    }), []);
    // reset sprawy po zmianie kontraktu (jak w TasksGlobalFilterBody)
    (0, react_1.useEffect)(() => {
        setValue("_case", undefined);
    }, [_contract?.id]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "_contract", className: "mb-2" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-1" }, "Kontrakt"),
            react_1.default.createElement(BussinesObjectSelectors_1.ContractSelector, { showValidationInfo: false })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-2" },
            react_1.default.createElement(StatusSelectors_1.ContractStatusSelector, { showValidationInfo: false, multiple: true, label: "Statusy kontraktu" })),
        _contract && (react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-2" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-1" }, "Sprawa"),
            react_1.default.createElement(BussinesObjectSelectors_1.CaseSelectMenuElement, { name: "_case", repository: casesFilterRepository, showValidationInfo: false, _contract: _contract, multiple: false })))));
}
/** Samodzielny lewy panel filtrów dla „Moje zadania" (przełączniki + doładowanie z serwera). */
function MyTasksFilterPanel({ onApply, toggles, }) {
    const methods = (0, react_hook_form_1.useForm)({ defaultValues: {}, mode: "onChange" });
    const submit = methods.handleSubmit((data) => onApply(data));
    const clear = () => {
        methods.reset({ _contract: "", statuses: "", _case: undefined });
        onApply({});
    };
    return (react_1.default.createElement("div", { className: "border rounded-3 p-2 mb-3 bg-light" },
        react_1.default.createElement("div", { className: "d-flex flex-column gap-1 mb-2" },
            react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "switch", id: "scrum-mytasks-fulltree", className: "mb-0", label: "Poka\u017C pe\u0142ne drzewo kontrakt\u00F3w (wszystkie zadania)", checked: toggles.fullTree, onChange: (e) => toggles.setFullTree(e.target.checked) }),
            react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "switch", id: "scrum-mytasks-onlymine", className: "mb-0", label: "Poka\u017C tylko moje zadania", checked: toggles.onlyMine, onChange: (e) => toggles.setOnlyMine(e.target.checked) }),
            react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "switch", id: "scrum-mytasks-hoursfilled", className: "mb-0", label: "Poka\u017C tylko zadania z uzupe\u0142nionymi godzinami", checked: toggles.hoursFilledOnly, onChange: (e) => toggles.setHoursFilledOnly(e.target.checked) })),
        react_1.default.createElement(FormContext_1.FormProvider, { value: methods },
            react_1.default.createElement(react_bootstrap_1.Form, { onSubmit: submit },
                react_1.default.createElement(Body, null),
                react_1.default.createElement("div", { className: "d-flex gap-2" },
                    react_1.default.createElement(react_bootstrap_1.Button, { type: "submit", size: "sm" }, "Filtruj"),
                    react_1.default.createElement(react_bootstrap_1.Button, { type: "button", size: "sm", variant: "outline-secondary", onClick: clear }, "Wyczy\u015B\u0107"))))));
}
